// extracted by mini-css-extract-plugin
export default {"content":"OpinionsTable_content__NoFfb"};